import { withInstall } from '@xzx-design/utils'
import _BaseList from './src/base-list'

export const BaseList = withInstall(_BaseList)
export default BaseList

export * from './src/base-list'
